import { useState, useContext, useRef } from 'react';
import '../App.css';
import Footer from '../components/Footer';
import { DynamicHeader, GetDimensions } from '../components/Header';
import { scrollToSection } from '../components/Header';
import { TitleCards } from '../TitleCards';

export default function CaesarCipher() {

    const { profile, project, contact } = useContext(TitleCards);

    const readMore = useRef(null);

    // const [copyButton, setCopyButton] = useState(true);
    const [pageRendered, setPageRendered] = useState(true);
    // const [decode, setDecode] = useState(false);

    // For the solving section of the caesar cipher
    // const [input, setInput] = useState('');
    // const [solved, setSolved] = useState(false);
    // const [ciphertext, setCipherText] = useState('');
    // const [plaintext, setPlainText] = useState('');
    // const [solvedshift, setSolvedShift] = useState(0);

    // For the build section of the cipher
    // const [buildInput, setBuildInput] = useState('');
    // const [shift, setShift] = useState(0);
    // const [buildPlaintext, setBuildPlaintext] = useState(''); 
    // const [buildCiphertext, setBuildCiphertext] = useState('');

    // const [unsuccessful, setUnsuccessful] = useState(false);

    // const handleSolve = async (e) => {
    //     e.preventDefault();
        
    //     // Using a Linux VM to host the flask api (for testing)
    //     const url = 'http://192.168.0.150:5000/caesar';

    //     try {
    //         const res = await fetch(url, {
    //             method: 'POST',
    //             headers: {
    //                 "Content-Type": "application/json"
    //             },
    //             body: JSON.stringify({
    //                 solved: solved,
    //                 ciphertext: ciphertext,
    //                 plaintext: plaintext,
    //                 solvedshift: solvedshift
    //             })
    //         });

    //         const data = await res.json();
    //         if (!res.ok) {
    //             console.log("PROBLEM!!!");
    //         }

    //         console.log(data);

    //         setSolved(data.solved)
    //         setPlainText(data.plaintext);
    //         setSolvedShift(data.solvedshift);
    //         setUnsuccessful(!solved);
    //     } catch(e) {
    //         console.log(e);
    //     } 
    // }

    // const handleBuild = async (e) => {
    //     e.preventDefault();

    //     // Using a Linux VM to host the flask api (for testing)
    //     const url = 'http://192.168.0.150:5000/buildcipher';

    //     try {
    //         const res = await fetch(url, {
    //             method: "POST",
    //             headers: {
    //                 "Content-Type": "application/json"
    //             },
    //             body: JSON.stringify({
    //                 ciphertext: buildCiphertext,
    //                 plaintext: buildPlaintext,
    //                 shift: shift
    //             })
    //         });

    //         const data = await res.json();
    //         if (!res.ok) {
    //             console.log("Response is not OK!");
    //         }

    //         setBuildCiphertext(data.ciphertext)
    //         setShift(data.shift)

    //     } catch (error) {
    //         console.log(error);
    //     }
    // }

    // const handleDecodeBtn = (input) => {
    //     setCipherText(input);
    //     setUnsuccessful(false);
    // }

    // const reset = (resetBtn) => {
    //     setSolved(false);
    //     setUnsuccessful(false);
    //     setInput('');
    //     if (!resetBtn) {
    //         setDecode(!decode);
    //         if (decode) { // Clicking Decode
    //             setCipherText('');
    //             setPlainText('');
    //         } else { // Clicking Encode
    //             setBuildInput('');
    //             setBuildCiphertext('');
    //             setBuildPlaintext('');
    //             setUnsuccessful(false);
    //         }
    //     }
    // }

    // const handleCopy = () => {
    //     navigator.clipboard.writeText(buildCiphertext);
    //     setCopyButton(false);
    // }

    const leafSVG = <path
        xmlns="http://www.w3.org/2000/svg"
        className='leaf'
        fill="#c4940f8e"
        d="M60.893,1.549c-0.136-0.269-0.386-0.462-0.679-0.525c-2.98-0.652-6.97-0.982-11.856-0.982  
        c-4.922,0-10.564,0.353-15.481,0.967C17.641,2.912,7,13.601,7,27v18.678L3.103,60.225c-0.428,1.598,0.523,3.244,2.122,3.674  
        c1.598,0.426,3.245-0.525,3.673-2.121L11.25,53H31c14.337,0,26-11.663,26-26c0-6.663,0-15.788,3.914-24.594  
        C61.036,2.132,61.028,1.816,60.893,1.549z M6.966,61.26c-0.143,0.532-0.691,0.849-1.224,0.707c-0.534-0.145-0.851-0.691-0.708-1.225  
        l2.552-9.686c0.405,0.672,0.998,1.212,1.712,1.55L6.966,61.26z M52.347,8.938c-0.073,0.027-6.014,2.301-14.545,9.321  
        c5.572-0.588,10.233,0.712,10.473,0.779c0.531,0.152,0.838,0.705,0.687,1.235C48.836,20.713,48.436,21,48,21  
        c-0.091,0-0.183-0.013-0.274-0.038c-0.064-0.019-6.464-1.784-12.916-0.135c-1.325,1.187-2.692,2.47-4.103,3.88  
        c-1.642,1.643-3.115,3.228-4.456,4.752c10.211-2.021,19.587,0.46,20.012,0.576c0.533,0.146,0.847,0.694,0.702,1.228  
        C46.844,31.708,46.44,32,46,32c-0.087,0-0.175-0.012-0.263-0.035c-0.107-0.029-10.88-2.889-21.475,0  
        c-0.051,0.014-0.103,0.016-0.154,0.021c-2.702,3.302-4.692,6.203-6.108,8.52c10.2-2.115,18.897,0.418,19.287,0.536  
        c0.529,0.159,0.829,0.716,0.671,1.244C37.828,42.72,37.431,43,37,43c-0.095,0-0.191-0.014-0.287-0.042  
        c-0.097-0.028-9.653-2.805-20.092-0.079c-1.184,2.166-1.671,3.434-1.684,3.468C14.788,46.75,14.406,47,14,47  
        c-0.115,0-0.232-0.021-0.347-0.062c-0.518-0.191-0.782-0.766-0.592-1.283c0.057-0.152,0.627-1.652,2.01-4.141  
        c1.837-9.547-0.028-18.21-0.048-18.297c-0.119-0.539,0.221-1.073,0.76-1.192c0.543-0.127,1.073,0.22,1.193,0.759  
        c0.069,0.312,1.422,6.557,0.713,14.457c1.414-2.121,3.204-4.565,5.464-7.261c1.693-10.294-0.111-18.677-0.13-18.763  
        c-0.119-0.539,0.221-1.073,0.76-1.193c0.539-0.116,1.073,0.221,1.193,0.76c0.073,0.33,1.569,7.275,0.571,16.458  
        c1.154-1.277,2.388-2.591,3.745-3.948c1.285-1.285,2.529-2.454,3.744-3.557v-0.008c1.873-6.556,0.052-11.312,0.033-11.359  
        c-0.202-0.513,0.049-1.094,0.562-1.297c0.51-0.206,1.092,0.044,1.297,0.557c0.075,0.188,1.599,4.106,0.657,9.863  
        C44.85,9.642,51.328,7.182,51.654,7.062c0.518-0.188,1.092,0.073,1.283,0.592C53.129,8.171,52.864,8.746,52.347,8.938z"
    />

    return (
        <div className='page-container caesar-page' style={{ backgroundSize: '100% 100%' }}>
            {pageRendered && scrollToSection('new_page')}
            {pageRendered && setPageRendered(false)}

            <DynamicHeader 
            visible={true}
            menu={GetDimensions().width < 600}
            profile={profile}
            project={project}
            contact={contact}
            />

            <div className='falling-leaves'>
                {[...Array(5)].map((_, i) => (
                    <svg key={i} className='falling-leaf-svg' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
                        {leafSVG}
                    </svg>
                ))}
            </div>

            <div className='caesar-column'>

                {GetDimensions().width < 600 && <div className='column'></div>}

                <div className='project-page'>

                    <div className='project-image-container caesar-title-container'>
                        <>CAESAR</> <>CIPHER</>
                    </div>

                    <div className='caesar-intro-container'>                   

                        <p>Try out my Caesar Cipher solver!<br/><br/>
                        Turn plaintext into ciphertext or bring your own ciphertext and my
                        algorithm will attempt to solve it.<br/><br/> 
                        To find out more about how this works and exactly how I made this 
                        page,
                        <br/>
                        <span 
                            onClick={() => scrollToSection('read_more', readMore)}
                        style={{ cursor: 'pointer', textDecoration: 'underline', color: 'blue' }}>Read Below.</span></p>

                    </div>
                    
                    <div className='maintainence'>
                        <p>The Caesar Cipher solver is currently under maintenance.
                            <br></br>
                            <br></br>
                            Please check back later.
                            <br></br>
                            <br></br>
                            Thank you for your understanding!    
                        </p>
                    </div>
                    {/* <div className='caesar-function-container'>
                        
                        <div className='encode-decode-btn'>
                            <div onClick={() => {decode ? reset(false) : setDecode(decode)}}
                            className={!decode ? 'encode-btn selected-btn' : 'encode-btn unselected-btn' }>
                                encode
                            </div>
                            <div onClick={() => {decode ? setDecode(decode) : reset(false)}}
                            className={decode ? 'decode-btn selected-btn' : 'decode-btn unselected-btn' }>
                                decode
                            </div>
                        </div>

                        {decode ? 
                        <div className='caesar-function'>
                            {/* DECODE SECTION (LEFT SIDE) 
                            <form className='cipher-form' onSubmit={handleSolve}>
                                <span style={{ color: '#423512', fontSize: '18px', fontWeight:'600', marginRight: '20px'}}>CipherText:</span>
                                <textarea
                                className='ciphertext-input'
                                placeholder='Enter your ciphertext here to be deciphered...'
                                name='ciphertext'
                                type='text'
                                value={input}
                                maxLength={100}
                                onChange={(e) => setInput(e.target.value)}
                                />
                                <button onClick={() => handleDecodeBtn(input)} className='cipher-solve-btn' type='submit'>
                                    Decode
                                </button>
                            </form>
                            <div className='cipher-result-container'>
                                <span style={{ color: '#423512', fontSize: '18px', fontWeight:'600', marginRight: '20px'}}>Result:</span>
                                {solved ? 
                                <div>
                                    <div className='cipher-result'>
                                        <div>{plaintext}</div>
                                    </div>
                                    <div style={{ width: '90%', display: 'flex', justifyContent: 'space-between' }}>
                                        <div>
                                            Shift: {solvedshift}
                                        </div>
                                        <button onClick={() => reset(true)} type='button' className='cipher-solve-btn' style={{ width: '30%'}}>
                                            Reset
                                        </button>
                                    </div>
                                    <div style={{ fontSize: '15px' }}>
                                        <p>Not your word?
                                        <span style={{ marginLeft: '5px', textDecoration: 'underline', color: 'blue' }}>Find out why</span></p>
                                    </div>
                                </div>
                                :
                                <div>
                                    <div className='cipher-result'/>
                                    {unsuccessful && 
                                    <div>
                                        <div className='cipher-fail result-shake'>
                                            Sorry, it seems I can't figure it out!
                                        </div>
                                        <span style={{ fontWeight: '300', fontSize: '17px', color: '#000000' }}>
                                            Your ciphertext might have some 
                                            unsual or uncommon words or phrases.
                                        </span>
                                    </div>
                                    }
                                </div>
                                }
                            </div>
                        </div>
                        :
                        <div className='caesar-function encode-function'>
                            {/* ENCODE SECTION (RIGHT SIDE) 
                            <form className='cipher-form' onSubmit={handleBuild}>
                                <span style={{ color: '#423512', fontSize: '18px', fontWeight:'600', marginRight: '20px'}}>PlainText:</span>
                                <textarea
                                className='ciphertext-input'
                                name='plaintext'
                                placeholder='Put your sentence here to scramble it!'
                                type='text'
                                value={buildInput}
                                minLength={3}
                                maxLength={100}
                                onChange={(e) => setBuildInput(e.target.value)}
                                />

                                <span style={{ color: '#423512', fontSize: '18px', fontWeight:'600', marginRight: '20px'}}>Shift:</span>
                                <input
                                style={{ width: '45px', height: '35px', fontSize: '25px', fontWeight: '600'}}
                                type='number'
                                min={0}
                                max={25}
                                value={shift}
                                onChange={(e) => setShift(e.target.value)}
                                />
                                <span className='random-suggestion'>
                                    <br/>
                                    *Leave it at 0 for a random shift!
                                </span>

                                <button onClick={() => setBuildPlaintext(buildInput)} className='cipher-solve-btn' type='submit'>
                                    Encode
                                </button>
                            </form>
                            <div className='cipher-result-container'>
                                <span style={{ color: '#423512', fontSize: '18px', fontWeight:'600', marginRight: '20px'}}>Result:</span>
                                {buildPlaintext !== '' ?
                                <div className='cipher-result'>
                                    <div>{buildCiphertext}</div>
                                </div>
                                :
                                <div className='cipher-result'/>}
                                <div className='copy-container'>
                                    {copyButton ? 
                                    <button onClick={() => handleCopy()}>Copy</button>
                                    :
                                    <span style={{ fontSize: '15px', color: '#85816c' }}>
                                        Text Copied
                                    </span>
                                    }
                                </div>
                            </div>
                        </div>
                        }
                        

                    </div> */}

                    <div ref={readMore} className='project-page-desc-container'>
                        <h2>THE CAESAR CIPHER</h2>
                        <span className='caesar-subtitle'>WHAT IS A CIPHER?</span>
                        <div className='project-page-desc'>
                            A cipher is an algorithm for performing encryption or 
                            decryption, a series of defined steps that can be followed as a procedure.
                            <br></br>
                            <br></br>
                            This page features the Caesar Cipher, a classic substitution cipher famously 
                            used by Julius Caesar to protect military communications. It works by 
                            "shifting" every letter in the plaintext a fixed number of positions down the alphabet. 
                            For example, with a shift of 3, A becomes D, B becomes E, and so on.
                        </div>
                        <h2>HOW DOES IT WORK?</h2>
                        <div className='project-page-desc'>
                            I have implemented the logic directly into this interface with two primary functions:
                            <br/>
                            <ul>
                                <li>
                                    <span className='caesar-subtitle' 
                                    style={{ fontWeight: '700' }}>Encode: </span>
                                    Transforms your plain English text into scrambled 
                                    ciphertext based on your chosen shift.
                                </li>
                                <li>
                                    <span className='caesar-subtitle' 
                                    style={{ fontWeight: '700' }}>Decode: </span>
                                    Reverses the process to reveal the original message.
                                </li>
                            </ul>
                            To prove the logic is authentic and not just "mirroring" your input, 
                            I encourage you to grab a Caesar-encrypted string from any other source, 
                            paste it into the decoder here, and watch the original message appear.
                        </div>
                        <h2>WHY I BUILT IT</h2>
                        <div className='project-page-desc'>
                            There are probably thousands of Caesar Cipher tools online. However, the goal 
                            of this project wasn't just to shift letters, it was to learn the 
                            process of architecting and deploying a "Full-Stack" System.
                            <br></br>
                            <br></br>
                            By treating a simple algorithm with the same rigor as a complex 
                            enterprise application, I gained hands-on experience with the 
                            following technologies:
                        </div>
                        <h2>THE TECH STACK</h2>
                        <span className='caesar-subtitle'>BREAKING DOWN THE STACK</span>
                        <div>
                            <ol>
                                <li>
                                    <span className='stack-title'>FLASK (The logic)</span>
                                    <div className='project-page-desc'>
                                        The core algorithm is written in Python using the Flask micro-framework. 
                                        Flask defines the API routes, handling the logic for whether a string 
                                        needs to be encoded or decoded before returning the result.
                                    </div>
                                </li>
                                <br></br>
                                <li>
                                    <span className='stack-title'>GUNICORN (The WSGI Server)</span>
                                    <div className='project-page-desc'>
                                        To move beyond a simple "development" server, I used Gunicorn. 
                                        This allows the application to handle multiple concurrent requests 
                                        by assigning "workers." While my current traffic may not require 
                                        high-performance scaling, implementing Gunicorn is essential for 
                                        understanding how to handle real-world user loads.
                                    </div>
                                </li>
                                <br></br>
                                <li>
                                    <span className='stack-title'>
                                        NGINX (The Reverse Proxy)</span>
                                    <div className='project-page-desc'>
                                        Nginx sits at the edge of the stack as a reverse proxy. 
                                        It serves two vital roles:<br/><br/>
                                        <span style={{ color: '#c4930f', fontWeight: '700', marginRight: '10px' }}>
                                            Security:
                                        </span> 
                                        It hides the 
                                        internal structure of the application server, shielding it 
                                        from direct exposure to the internet.<br/><br/>
                                        <span style={{ color: '#c4930f', fontWeight: '700', marginRight: '10px' }}>
                                            Efficiency:
                                        </span> 
                                        It handles 
                                        incoming traffic and passes it to Gunicorn, acting as a 
                                        traffic cop to ensure data is transferred safely between my server and your device.
                                    </div>
                                </li>
                                <br></br>
                                <li>
                                    <span className='stack-title'>REACT (The Frontend)</span>
                                    <div className='project-page-desc'>
                                        The user interface is built with React. It provides a reactive, 
                                        modern experience that communicates with the backend API in real-time. 
                                        This ensures the data is displayed clearly and that the navigation 
                                        remains intuitive and fluid.
                                    </div>
                                </li>
                            </ol>
                        </div>
                    </div>

                </div>
                {GetDimensions().width < 600 && <div className='column'></div>}
            </div>
            <Footer/>              
        </div>
    )
}